import React from 'react';
import ReduxToastr from 'react-redux-toastr';

export const CMSToaster = () =>  (
    <ReduxToastr
        timeOut={3000}
        newestOnTop={true}
        position='top-right'
        transitionIn='fadeIn'
        transitionOut='fadeOut'
        attention={true}
        progressBar
        preventDuplicates
    />
)


// WEBPACK FOOTER //
// ./src/components/toaster/toaster.js